import fullpage from "fullpage.js"
// import Typed from 'typed.js'

document.addEventListener("DOMContentLoaded", (event) => {

  // const typed = new Typed('.things-i-do', {
  //   strings: ["Web-Entwickler", "Dozent", "Gründer von samplebar.de"],
  //   typeSpeed: 120,
  //   backSpeed: 70,
  //   loop: true
  // })

  let now = new Date()
  let hours = now.getHours()
  let greet = "Hallo"

  if (hours > 18)
    { greet = "Guten Abend," }
  else if (hours > 9)
    { greet = "Guten Tag," }
  else if (hours > 3)
    { greet = "Guten Morgen," }


  let elem = document.querySelector("#greet")
  if (elem) {
    elem.innerHTML = greet
  }

  let welcome = document.querySelector("#fullpage")
  if (welcome) {
    new fullpage('#fullpage', {
      licenseKey: "QNG1I-QS5XH-YHOY7-1IB47-SHQSL",
      credits: {
        enabled: false
      }
    })
  }

  const htmlElement = document.querySelector("html")
  if(htmlElement.getAttribute("data-bs-theme") === 'auto') {
    function updateTheme() {
      if (localStorage.getItem('bsTheme')) {
        document.querySelector("html").setAttribute("data-bs-theme", localStorage.getItem('bsTheme'))
      } else {
        document.querySelector("html").setAttribute("data-bs-theme",
          window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light")
      }
    }
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', updateTheme)
    updateTheme()
  }

  const switchElement = document.getElementById('darkModeSwitch')
  switchElement.checked = htmlElement.getAttribute("data-bs-theme") === 'dark'
  switchElement.addEventListener('change', function () {
    if (this.checked) {
      htmlElement.setAttribute('data-bs-theme', 'dark')
      if (window.matchMedia("(prefers-color-scheme: light)").matches) {
        localStorage.setItem('bsTheme', 'dark')
      } else {
        localStorage.removeItem('bsTheme')
      }
    } else {
      htmlElement.setAttribute('data-bs-theme', 'light')
      if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
        localStorage.setItem('bsTheme', 'light')
      } else {
        localStorage.removeItem('bsTheme')
      }
    }
  })

})
